import { ResponsiveGrid } from "@enxcs/dap-ui-stratos";
import styled from "styled-components";

export const ResponsiveGridStyled = styled(ResponsiveGrid)`
  flex-grow: 1;
  height: 100%;
  grid-template-rows: auto 1fr;
`;
